// Admin bar entry point — runs on ALL WP admin pages
// Separate from the React settings page entry (src/main.tsx)

// Inject admin bar styles
const style = document.createElement('style');
style.textContent = `
  /* Conditional menu items hidden by default */
  #wpadminbar .rightplace-conditional-menu,
  #wpadminbar .rightplace-resource-menu {
    display: none;
  }

  /* Status dot */
  .rp-admin-bar-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-left: 6px;
    vertical-align: middle;
  }
  .rp-admin-bar-dot--healthy {
    background-color: #22c55e;
  }
  .rp-admin-bar-dot--unhealthy {
    background-color: #ef4444;
  }
  .rp-admin-bar-dot--checking {
    background-color: #f59e0b;
    animation: rp-pulse 1.5s ease-in-out infinite;
  }
  @keyframes rp-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
`;
document.head.appendChild(style);

import Alpine from 'alpinejs'
import { createAdminBarController } from './controllers/adminBarController.js'

// Make admin bar controller available globally for Alpine.js
window.rpAdminBar = createAdminBarController

// Initialize Alpine.js for the admin bar
window.Alpine = Alpine
Alpine.start()
